// @module Cart
define('QuickOrder.View.LimitQty', [
  'QuickOrder.View',
  'GlobalViews.Message.View',
  'LimitItemQuantity.Helper',
  'Configuration',
  'jQuery',
  'underscore'
], function CartDetailedViewLimitQty(
  QuickOrderView,
  GlobalViewsMessageView,
  Helper,
  Configuration,
  jQuery,
  _
) {
  'use strict';

  // @class Cart.Detailed.View This is the Shopping Cart view @extends Backbone.View
  return _.extend(QuickOrderView.prototype, {

    addNewLine: _.wrap(QuickOrderView.prototype.addNewLine, function updateItemQuantityWrap(fn) {
      var event = _.toArray(arguments).slice(1);
      var enabledForQuickAdd = Configuration.get('limitItemQuantity.enabledForQuickAdd');
      var line;
      var item;
      var itemInCart;
      var quantity;
      var quantityAvailable;
      var errorInsufficientAmount = Helper.insufficientAmount;
      var errorMessage;
      var itemValidation;
      var placeHolder;
      var existingMessage;
      this.quickAddViewComponent.qtyError = false;
      if (enabledForQuickAdd) {
        line = arguments[1].selectedLine;
        item = line.get('item');
        itemInCart = Helper.findItemInCart(item);
        quantity = line.get('quantity');
        quantityAvailable = item.get('quantityavailable');
        placeHolder = this.$el.find('.quick-add-box-right-main');
        existingMessage = this.$(placeHolder).find('.global-views-message-error');
        if (itemInCart) {
          quantity += itemInCart.get('quantity');
        }
        itemValidation = Helper.validateItem({
          quantityavailable: quantityAvailable,
          isbackorderable: item.get('isbackorderable')
        }, quantity);
        if (existingMessage && existingMessage.length > 0) {
          jQuery(existingMessage).remove();
        }
        if (!itemValidation.isValid) {
          errorMessage = errorInsufficientAmount.errorMessage.replace('[QTY]', quantityAvailable);
          this.showQtyErrorMessage(errorMessage, placeHolder);
          this.quickAddViewComponent.qtyError = true;
          this.quickAddViewComponent.quantityAvailableToAdd = quantityAvailable - (itemInCart ? itemInCart.get('quantity') : 0);
        } else {
          fn.apply(this, event);
        }
      } else {
        fn.apply(this, event);
      }
    }),

    showQtyErrorMessage: function showQtyErrorMessage(errorMessage, placeHolder) {
      var errorMessageItems = new GlobalViewsMessageView({
        message: errorMessage,
        type: 'error',
        closable: true
      });
      this.$(placeHolder).append(errorMessageItems.render().$el.html());
    }
  });
});
